import { ProductPriceDataResponseType } from "magic-shared-types";
import { api } from "../api";
import { BASE_SERVER_PATH } from "../../constant";

export const myServerApis = api.injectEndpoints({
  endpoints: (builder) => ({
    getProductPriceData: builder.query<
      ProductPriceDataResponseType,
      { bluprintId: number }
    >({
      query: ({ bluprintId }) => ({
        url: `${BASE_SERVER_PATH}/api/card-trader-product/${bluprintId}`,
        method: "GET",
        headers: {
          "x-requires-auth": "true",
        },
      }),
    }),
  }),
});

export const { useGetProductPriceDataQuery } = myServerApis;
